import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Filter, FilterOperation } from "src/app/core/jsonapi/filter";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { Service } from "src/app/core/jsonapi/service";
import { CaseServiceMaterial } from "../_types/case-service-material";

@Injectable({
    providedIn: 'root',
})
export class CaseServiceMaterialsService extends Service<CaseServiceMaterial> {
    public override type = 'caseServiceMaterials';
    public override url = 'attendance/caseServiceMaterials';

    /** Ids de los materiales asociados a una cita. */
    public async loadMaterialIdsFor(caseServiceId: string): Promise<string[]> {
        let response = await firstValueFrom(this.all(this.paramsFor(caseServiceId)));
        return response.data
            .map((relation: CaseServiceMaterial) => relation.materialId)
            .filter((id: string | undefined) => !!id) as string[];
    }

    /**
     * Deja la cita relacionada exactamente con los materiales indicados. A diferencia del patron de
     * caseStateCaseModes, aqui se hace diff en vez de borrar e insertar todo: las citas se auditan y
     * reescribir relaciones que no han cambiado ensucia el historial.
     */
    public async syncForCaseService(caseServiceId: string, materialIds: string[]): Promise<void> {
        let existing = await firstValueFrom(this.all(this.paramsFor(caseServiceId)));

        for (const relation of existing.data) {
            if (materialIds.indexOf(relation.materialId) < 0) {
                await firstValueFrom(this.delete(relation.id));
            }
        }

        let currentIds = existing.data.map((relation: CaseServiceMaterial) => relation.materialId);
        for (const materialId of materialIds) {
            if (currentIds.indexOf(materialId) < 0) {
                let relation = new CaseServiceMaterial();
                delete relation.id;
                relation.caseServiceId = caseServiceId;
                relation.materialId = materialId;
                await firstValueFrom(this.save(relation));
            }
        }
    }

    private paramsFor(caseServiceId: string): IParamsCollection {
        return {
            filter: FilterBuilder.fromObject({
                caseServiceId: new Filter(FilterOperation.equals, 'caseServiceId', '', caseServiceId)
            }).build(),
            page: { number: 1, size: 200 }
        };
    }
}
